import { AuthContextProps } from "../components/auth-context";
import { getData } from "./core";

export default class TicketSubjectsApi {
  static uri = "TicketSubjects";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }
  get(id: number) {
    return getData({ uri: TicketSubjectsApi.uri, id, context: this.context });
  }
}
